import {LogicTestReportChartProps} from './types';

export function copyAndSortQuestions(questions: LogicTestReportChartProps['questions']) {
    return questions.slice().sort((a, b) => a.questionOrder - b.questionOrder);
}
